// src/components/credits/CreditUsageTable.jsx
//
// Renders a CreditUsageResponse's per-user buckets.
//   - Members get email: null -> the Utente column falls back to a short user id.
//   - money column ($) shown only when showMoney (superadmin); cost_usd null otherwise.
//   - buckets: [] -> empty-state row (never a spinner/error).
import React from 'react';
import AdminTable from '../../admin/components/AdminTable.jsx';
import { formatCredits, formatMoney } from '../../utils/creditsFormat.js';

const FONT = "'DM Sans', sans-serif";
const COLOR = { text: '#1d1d1f', muted: '#6c6c6d', border: 'rgba(0,0,0,0.08)' };
const cardStyle = {
  background: '#fff', borderRadius: 10, border: `1px solid ${COLOR.border}`,
  padding: '20px 22px', fontFamily: FONT, color: COLOR.text,
};

export default function CreditUsageTable({ usage, showMoney = false, loading = false }) {
  const buckets = usage?.buckets || [];

  const columns = [
    {
      key: 'user', label: 'Utente',
      render: (row) => row.email || (row.user_id ? `${row.user_id.slice(0, 8)}…` : 'Sconosciuto'),
    },
    { key: 'credits', label: 'Crediti', width: '140px', render: (row) => formatCredits(row.credits) },
    ...(showMoney ? [{
      key: 'cost_usd', label: 'Costo', width: '120px',
      render: (row) => formatMoney(row.cost_usd) || '—',
    }] : []),
  ];

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, marginBottom: 14, flexWrap: 'wrap' }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, margin: 0 }}>Utilizzo per utente</h3>
        {usage && (
          <span style={{ fontSize: 12, color: COLOR.muted }}>
            Totale: <strong style={{ color: COLOR.text }}>{formatCredits(usage.total_credits)}</strong> crediti
            {showMoney && formatMoney(usage.total_cost_usd) ? ` · ${formatMoney(usage.total_cost_usd)}` : ''}
          </span>
        )}
      </div>
      <AdminTable
        columns={columns}
        rows={buckets}
        loading={loading}
        emptyMessage="Nessun utilizzo in questo periodo"
        getRowKey={(row, i) => row.user_id || `none-${i}`}
      />
    </div>
  );
}
